const getPatientTypeNameByType = (type, t) => {
    switch (type) {
        case 'Kiosk':
            return t("Global.Patients.Type.Kiosk");
        case 'Portal':
            return t("Global.Patients.Type.Portal");
        case 'Enrolled':
            return t("Global.Patients.Type.Enrolled");
        case 'PMS':
            return t("Global.Patients.Type.PMS");
        case 'KAKTUS_PATIENT':
            return t("Global.Patients.Type.Kaktus_Patient");
        default:
            break;
    }
}

export default getPatientTypeNameByType



// WEBPACK FOOTER //
// ./src/components/common/getPatientTypeNameByType.js